import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import { useEffect, useState } from "react";
import { supabase } from "./supabaseClient";

import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";

function App() {
    const [session, setSession] = useState(null);
    const [yukleniyor, setYukleniyor] = useState(true);

    useEffect(() => {
        supabase.auth.getSession().then(({ data: { session } }) => {
            setSession(session);
            setYukleniyor(false);
        });
        const { data: { subscription } } = supabase.auth.onAuthStateChange(
            (_event, session) => setSession(session)
        );
        return () => subscription.unsubscribe();
    }, []);

    if (yukleniyor) return <div style={{display:"flex",justifyContent:"center",alignItems:"center",height:"100vh"}}>Yükleniyor...</div>;

    return (
        <BrowserRouter>
            <Toaster position="top-right" />
            <Routes>
                <Route path="/giris"  element={!session ? <Login />    : <Navigate to="/" />} />
                <Route path="/kayit"  element={!session ? <Register /> : <Navigate to="/" />} />
                <Route path="/*"      element={session  ? <Dashboard /> : <Navigate to="/giris" />} />
            </Routes>
        </BrowserRouter>
    );
}

export default App;